import { render, staticRenderFns } from "./DefRegisterList.vue?vue&type=template&id=6b75d1ba&scoped=true&"
import script from "./DefRegisterList.vue?vue&type=script&lang=js&"
export * from "./DefRegisterList.vue?vue&type=script&lang=js&"
import style0 from "./DefRegisterList.vue?vue&type=style&index=0&id=6b75d1ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b75d1ba",
  null
  
)

export default component.exports